
import { cx } from '@client/shared/lib/cx.ts';
import { STEPS, STEP_META, type Step } from './use-new-listing-form.ts';
import styles from './NewListing.module.css';

export interface StepperProps {
  activeIndex: number;
  onJump: (step: Step) => void;
}

export function Stepper({ activeIndex, onJump }: StepperProps) {
  return (
    <ol className={styles.stepper} aria-label="New listing steps">
      {STEPS.map((step, i) => {
        const state = i < activeIndex ? 'done' : i === activeIndex ? 'current' : 'upcoming';
        const clickable = i < activeIndex;
        return (
          <li key={step} className={styles.stepperItem}>
            <button
              type="button"
              className={cx(styles.stepperButton, styles[`step-${state}`])}
              data-state={state}
              aria-current={state === 'current' ? 'step' : undefined}
              disabled={!clickable}
              onClick={() => clickable && onJump(step)}
            >
              <span className={styles.stepperIndex} aria-hidden="true">
                {state === 'done' ? <DoneTick /> : i + 1}
              </span>
              <span className={styles.stepperText}>
                <span className={styles.stepperTitle}>{STEP_META[step].title}</span>
                <span className={styles.stepperBlurb}>{STEP_META[step].blurb}</span>
              </span>
            </button>
            {i < STEPS.length - 1 && <span className={styles.stepperRail} aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  );
}

function DoneTick() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M3.5 8.5l3 3 6-7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
